import React, { Component } from "react";
import ResponsiveReactGridLayout from "react-grid-layout";
import "react-resizable/css/styles.css";
import "react-grid-layout/css/styles.css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import SectionFooter from "./sectionfooter";
import imagesuemzuege from "./gallerylists/imagesuemzuege";
import imageskarneval from "./gallerylists/imageskarneval";
import imagesold from "./gallerylists/imagesold";
import imageshistory from "./gallerylists/imageshistory";

class Gallery extends Component {
  render() {
    var layout = [
      { i: "gallery1", x: 0, y: 0, w: 1, h: 1, static: true, autoSize: true },
      { i: "gallery2", x: 1, y: 0, w: 1, h: 1, static: true, autoSize: true },
      { i: "gallery3", x: 0, y: 1, w: 1, h: 1, static: true, autoSize: true },
      { i: "gallery4", x: 1, y: 1, w: 1, h: 1, static: true, autoSize: true }
    ];
    return (
      <section id="gallery">
        <h1>Bilder</h1>
        <ResponsiveReactGridLayout
          className="layout"
          style={{ height: "880px" }}
          layout={layout}
          cols={3}
          rowHeight={450}
          width={1200}
          useCSSTransforms={true}
        >
          <div key={"gallery1"} className="clearfix">
            <h3 className="entry-title">Tambour Korps bei den Umz&uuml;gen</h3>
            <ImageGallery
              lazyLoad={true}
              showIndex={true}
              slideOnThumbnailHover={true}
              items={imagesuemzuege}
              slideInterval={2000}
            />
          </div>
          <div key={"gallery2"}>
            <h3 className="entry-title">
              Tambour Korps in Fr&uuml;heren Jahren
            </h3>
            <ImageGallery
              lazyLoad={true}
              showIndex={true}
              slideOnThumbnailHover={true}
              items={imagesold}
              slideInterval={2000}
            />
          </div>
          <div key={"gallery3"}>
            <h3 className="entry-title">Tambour Korps Karneval</h3>
            <ImageGallery
              lazyLoad={true}
              showIndex={true}
              slideOnThumbnailHover={true}
              items={imageskarneval}
              slideInterval={2000}
            />
          </div>
          <div key={"gallery4"}>
            <h3 className="entry-title">Tambour Korps Archiv Bilder</h3>
            <ImageGallery
              lazyLoad={true}
              showIndex={true}
              slideOnThumbnailHover={true}
              items={imageshistory}
              slideInterval={2000}
            />
          </div>
        </ResponsiveReactGridLayout>
        <SectionFooter />
      </section>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/imagegallery.js